var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69027 11.7995C0.766418 12.7233 0.770434 14.2252 1.69924 15.154L2.96056 16.4153C3.19276 16.6475 3.56576 16.6413 3.84207 16.467C4.87175 15.8173 6.25328 15.9443 7.15486 16.8459C8.05644 17.7475 8.18347 19.129 7.53375 20.1587C7.35939 20.435 7.35319 20.808 7.58539 21.0402L8.84671 22.3015C9.77551 23.2303 11.2774 23.2343 12.2013 22.3105L22.3097 12.202C23.2336 11.2781 23.2296 9.77625 22.3008 8.84744L21.0394 7.58612C20.8072 7.35392 20.4342 7.36012 20.1579 7.53448C19.1283 8.18421 17.7467 8.05717 16.8451 7.15559C15.9436 6.25401 15.8165 4.87248 16.4663 3.84281C16.6406 3.5665 16.6468 3.19349 16.4146 2.96129L15.1533 1.69997C14.2245 0.771166 12.7226 0.76715 11.7987 1.691L1.69027 11.7995ZM11.9999 15C13.6568 15 14.9999 13.6569 14.9999 12C14.9999 10.3431 13.6568 9 11.9999 9C10.3431 9 8.99994 10.3431 8.99994 12C8.99994 13.6569 10.3431 15 11.9999 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.7c8a17e6aa44038b3279da5e747b72dd.svg";
export { ForwardRef as ReactComponent };